export default __webpack_public_path__ + "static/media/books.83fe42e7.svg";